export default "__VITE_ASSET__B3s812Fg__"